var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('v-chip',{attrs:{"color":_vm.value === 'Error' ? 'error' : 'success',"outlined":""}},[_vm._v(" "+_vm._s(_vm.value || 'Not Found')+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }